import styled from 'styled-components';

export const Wrapper = styled.div<{ $isOpen: boolean }>`
  display: flex;
  width: 100%;
  align-items: center;
  max-width: 840px;
  justify-content: flex-start;
  flex-wrap: wrap;
  max-height: ${({ $isOpen }) => ($isOpen ? '100%' : '50px')};
  overflow-x: hidden;
  gap: 8px;
  padding: 10px 0px;
`;

export const PracticalCaseWrapper = styled.div`
  display: flex;
  padding: 1px 7px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 32px;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid ${({ theme }) => theme.colors.black4};
  background: ${({ theme }) => theme.colors.white};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  flex-shrink: 0;
  cursor: pointer;

  &:hover {
    border-color: ${({ theme }) => theme.colors.black6};
    background: ${({ theme }) => theme.colors.black1};
  }

  &:active {
    border-color: ${({ theme }) => theme.colors.black9};
    background: ${({ theme }) => theme.colors.black1};
  }
`;

export const WrapperWithButton = styled.div`
  display: flex;
  gap: 12px;
  align-items: flex-start;
  justify-content: flex-start;
`;

export const ButtonWrapper = styled.div`
  padding: 10px 0px;

  .ant-btn-text {
    padding: 1px 7px;
  }
`;
